require('./riskProduct.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;

// @ constants
const { LANDING_RISK_INDICATOR } = require('constants/flagBasedFeatures');

class RiskProduct extends React.Component {

    buildAlertLiquidity() {
        return (
            <div className="risk-product__alert-liquidity">
                <div className="risk-product__alert-liquidity-title">
                    <FormattedText value="riskProduct-riskProduct_liquidityTitle" />
                </div>
                <div className="risk-product__alert-liquidity-icons">
                    <i className="icon-candado" />
                    <i className="icon-candado" />
                </div>
                <div className="risk-product__alert-liquidity-text">
                    <FormattedText value="riskProduct-riskProduct_liquidityText" />
                </div>
            </div>
        );
    }

    render() {
        const {
            immFlagBasedFeatures,
            indicatorText,
            isAlertLiquidity
        } = this.props;
        let content = null;
        
        if (immFlagBasedFeatures.get(LANDING_RISK_INDICATOR)) {
            let indicator;
            let alertLiquidity;

            if (!!indicatorText) {
                indicator = (
                    <div className="risk-product__indicator">
                        {indicatorText}
                    </div>
                );
            }

            if (isAlertLiquidity) {
                alertLiquidity = this.buildAlertLiquidity();
            }

            content = (
                <div className="risk-product">
                    <div className="risk-product__box">
                        <div className="risk-product__box-value col-xs-6">
                            <div className="risk-product__level-value">
                                <FormattedText
                                    className="risk-product__level-value-upper"
                                    value="riskProduct-riskProduct_indicatorValueUp"
                                />
                                <FormattedText value="riskProduct-riskProduct_indicatorValueDown" />
                            </div>
                            <div className="risk-product__level">
                                <FormattedText value="riskProduct-riskProduct_indicatorDescriptionValue" />
                            </div>
                        </div>
                        <FormattedText
                            className="risk-product__box-legal col-xs-6"
                            value="riskProduct-riskProduct_indicatorDescriptionLegal"
                        />
                    </div>
                    {alertLiquidity}
                    {indicator}
                </div>
            );
        }

        return content;
    }
}

RiskProduct.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    indicatorText: PropTypes.string,
    isAlertLiquidity: PropTypes.bool
};

RiskProduct.defaultProps = {
    isAlertLiquidity: false,
};

module.exports = RiskProduct;
